import { detect } from "detect-browser";
import { DcfSdkEnumsObj } from "../enums/DcfSdkEnum";
/** @internal */
export var DEFAULT_COMPLIANCE_SETTINGS = {
    privacy: {
        acceptedVersion: "LATEST",
        latestVersion: "LATEST",
        latestVersionUri: "https://www.mastercard.com/global/click-to-pay/country-listing/privacy.html",
    },
    tnc: {
        acceptedVersion: "LATEST",
        latestVersion: "LATEST",
        latestVersionUri: "https://www.mastercard.com/global/click-to-pay/country-listing/terms.html",
    },
    cookie: {
        acceptedVersion: "LATEST",
        latestVersion: "LATEST",
        latestVersionUri: "https://www.mastercard.com/global/click-to-pay/en-us/privacy-notice.html",
    },
};
/** @internal */
export var isDcfSuppressedCheck = function (dcf) {
    if (dcf !== DcfSdkEnumsObj.MASTERCARD) {
        return false;
    }
    var dcfSuppressedBrowsers = ["crios", "safari", "ios-webview", "ios"];
    var browserInfo = detect();
    var detectedBrowser = browserInfo === null || browserInfo === void 0 ? void 0 : browserInfo.name;
    if (!detectedBrowser) {
        return false;
    }
    return dcfSuppressedBrowsers.includes(detectedBrowser);
};
/** @internal */
export var getDcfSuppressedDpaTransactionOptions = function (dpaTransactionOptions) {
    var dcfSuppressedDpaTransactionOptionsClone = JSON.parse(JSON.stringify(dpaTransactionOptions));
    dcfSuppressedDpaTransactionOptionsClone.confirmPayment = false;
    dcfSuppressedDpaTransactionOptionsClone.customInputData = {
        "com.mastercard.dcfExperience": "WITHIN_CHECKOUT",
    };
    return dcfSuppressedDpaTransactionOptionsClone;
};
